export function createFrame(id: string, styleStr?: string) {
  if (document.getElementById(id)) {
    return Promise.reject(`Container ${id} already created!`);
  }

  const el = document.createElement('div');

  el.id = id;

  document.body.appendChild(el);

  if (styleStr) {
    const style = document.createElement('style');

    style.innerHTML = styleStr;
    style.id = `style-${id}`;

    document.head.appendChild(style);
  }

  return Promise.resolve(el);
}

export function attachToNode(nodeId: string, element: HTMLElement) {
  const node = document.getElementById(nodeId);

  if (!node) throw new Error(`Could not find div with id ${nodeId}`);
  node.insertBefore(element, node.firstChild);

  return node;
}

export function applyZIndex(element: HTMLElement, zIndex: number) {
  if (!(element instanceof HTMLElement) || typeof zIndex !== 'number') return;

  element.style.zIndex = `${zIndex}`;
}
